module.exports = __webpack_public_path__ + "media/images/firmware-6cb7f6f863e03cb51250b7cb5ab056a6.png";